import { OfferedSinceOptionVariant } from './types';

const OFFERED_SINCE_VARIANT_LABELS = [
  [OfferedSinceOptionVariant.NO_PREFERENCE, 'No preference'],
  [OfferedSinceOptionVariant.LAST_7_DAYS, 'Last 7 days'],
  [OfferedSinceOptionVariant.LAST_30_DAYS, 'Last 30 days'],
  [OfferedSinceOptionVariant.LAST_90_DAYS, 'Last 90 days'],
] as const;

type OfferedSinceOptionTuple = (typeof OFFERED_SINCE_VARIANT_LABELS)[number];
export type OfferedSinceOption = {
  id: OfferedSinceOptionTuple[0];
  optionName: OfferedSinceOptionTuple[1];
};

export const OFFERED_SINCE_OPTIONS: OfferedSinceOption[] =
  OFFERED_SINCE_VARIANT_LABELS.map(([id, label]) => ({
    id,
    optionName: label,
  }));

export const OFFERED_SINCE_SELECT_OPTIONS = OFFERED_SINCE_VARIANT_LABELS.map(
  ([value, label]) => ({ value, label, disabled: false }),
);
